export default "__VITE_ASSET__WMVkjQLy__"